// extracted by mini-css-extract-plugin
export var numberInputContainer = "_4d-0";
export var startPickingButton = "_4d-1";